import * as THREE from 'three';
import Transition from './Transition.js';

export default class Renderer {
    constructor() {
        this.experience = new Transition();
        this.canvas = this.experience.canvas;
        this.sizes = this.experience.sizes;
        this.scene = this.experience.scene;
        this.camera = this.experience.camera;

        this.setInstance();
    }

    setInstance() {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: false,
            preserveDrawingBuffer: true,
        });
        this.instance.outputColorSpace = THREE.SRGBColorSpace;
        this.instance.setSize(this.sizes.width, this.sizes.height);
        this.instance.setPixelRatio(this.sizes.pixelRatio);
        this.instance.setClearAlpha(0);
        this.instance.setClearColor(0xff0000, 0);
        this.instance.gammaOutput = true;
        this.instance.gammaFactor = 2.2;
        this.instance.outputColorSpace = THREE.SRGBColorSpace;
    }

    resize() {
        this.instance.setSize(this.sizes.width, this.sizes.height);
        this.instance.setPixelRatio(this.sizes.pixelRatio);
    }

    update() {
        this.instance.render(this.scene, this.camera.instance); 
    }

    destroy() {
        this.instance.dispose();
    }
}